
/**
 * Helper to render a QR code with a logo in the center to a canvas.
 * Useful for thermal printing where we need to send the final image.
 */
export const renderQrWithLogoToCanvas = (svgElement, logoImageElement, size = 384) => {
  return new Promise((resolve) => {
    try {
      if (!svgElement) return resolve(null)

      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')

      // Fill background white
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, size, size)

      // Convert SVG to Image
      const xml = new XMLSerializer().serializeToString(svgElement)
      const svg64 = btoa(unescape(encodeURIComponent(xml)))
      const b64Start = 'data:image/svg+xml;base64,'
      const image64 = b64Start + svg64

      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        // Draw QR
        ctx.drawImage(img, 0, 0, size, size)

        // Draw Logo in center (if provided)
        if (logoImageElement) {
          const logoSize = size * 0.22 // ~84px for 384px size
          const logoX = (size - logoSize) / 2
          const logoY = (size - logoSize) / 2

          // White background for logo
          ctx.fillStyle = 'white'
          ctx.fillRect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10)

          // Draw logo
          ctx.drawImage(logoImageElement, logoX, logoY, logoSize, logoSize)
        }

        resolve(canvas)
      }
      img.onerror = () => resolve(null)
      img.src = image64
    } catch (err) {
      console.error('Canvas render error:', err)
      resolve(null)
    }
  })
}
